import { Flask } from '@/core/ui/icons';

/** Chamada para manipulação sob receita (Central Farma). */
export function PromoBanner() {
  return (
    <section className="relative overflow-hidden rounded-3xl bg-canvas-deep">
      <div aria-hidden className="absolute inset-0">
        <div className="absolute inset-y-0 right-0 w-3/5 bg-linear-to-l from-slate-300/25 via-slate-400/10 light:from-neutral-200/60 light:via-neutral-100/40 to-transparent" />
        <div className="absolute -right-10 -bottom-16 size-72 rounded-full bg-brand-500/20 blur-3xl light:hidden" />
        <div className="absolute top-6 right-[18%] size-40 rounded-full bg-amber-200/20 blur-2xl light:hidden" />
        <Flask
          className="absolute top-1/2 right-[8%] size-40 -translate-y-1/2 rotate-12 text-white/10 light:text-black/5"
          weight="thin"
        />
      </div>
      <div className="relative max-w-md px-6 py-8 sm:px-8">
        <h2 className="text-2xl leading-tight font-bold tracking-tight sm:text-3xl">
          Sua <span className="text-brand-400">fórmula personalizada</span> começa aqui
        </h2>
        <p className="mt-2 text-sm text-fg-muted">Envie sua receita e manipulamos sob medida para você.</p>
      </div>
    </section>
  );
}
